import { NgTemplateOutlet } from '@angular/common';
import { Component, inject, TemplateRef } from '@angular/core';
import { ToastService } from '@core/services/toast.service';
import { LucideCircleAlert, LucideCircleCheckBig, LucideInfo, LucideTriangleAlert, LucideX } from '@lucide/angular';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-toasts-container',
  standalone: true,
  imports: [
    NgbToastModule,
    NgTemplateOutlet,
    TranslateModule,
    LucideCircleCheckBig,
    LucideCircleAlert,
    LucideInfo,
    LucideTriangleAlert,
    LucideX,
  ],
  template: `
    @for (toast of toastService.toasts(); track toast.id) {
      <ngb-toast
        [class]="'custom-toast ' + toast.type"
        [autohide]="true"
        [delay]="toast.delay || 5000"
        (hidden)="toastService.remove(toast)"
      >
        <div class="toast-content d-flex align-items-start gap-3">
          <!-- Icon theo loại -->
          <div class="toast-icon-box">
            @switch (toast.type) {
              @case ('success') {
                <svg lucideCircleCheckBig class="icon-success"></svg>
              }
              @case ('error') {
                <svg lucideCircleAlert class="icon-error"></svg>
              }
              @case ('warning') {
                <svg lucideTriangleAlert class="icon-warning"></svg>
              }
              @case ('info') {
                <svg lucideInfo class="icon-info"></svg>
              }
            }
          </div>

          <!-- Nội dung -->
          <div class="toast-body-inner flex-grow-1">
            <h6 class="toast-header-text mb-1">
              {{ toast.header || 'COMMON.NOTIFICATION' | translate }}
            </h6>
            <div class="toast-message-text">
              @if (isTemplate(toast.textOrTpl)) {
                <ng-container [ngTemplateOutlet]="toast.textOrTpl"></ng-container>
              } @else {
                {{ toast.textOrTpl | translate }}
              }
            </div>
          </div>

          <!-- Nút đóng tùy chỉnh -->
          <button
            class="btn-close-custom"
            (click)="toastService.remove(toast)"
            [attr.aria-label]="'COMMON.CLOSE' | translate"
          >
            <svg lucideX></svg>
          </button>
        </div>
      </ngb-toast>
    }
  `,
  styleUrl: './toasts-container.component.scss',
  host: {
    class: 'toast-container position-fixed top-0 end-0 p-4',
    style: 'z-index: 2000',
  },
})
export class ToastsContainerComponent {
  toastService = inject(ToastService);

  /** Type Predicate giúp Angular Template hiểu đúng kiểu dữ liệu */
  isTemplate(val: string | TemplateRef<unknown>): val is TemplateRef<unknown> {
    return val instanceof TemplateRef;
  }
}
